module.exports = "/assets/7db5ef0b4455db84cdf44856dff5f856.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/KF.png
// module id = 1543
// module chunks = 0